









import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'

settings =
  name: 'DevStats'
  components: { SuperContainerView }
  resources:
    devStats:
      resourceName: 'devStats'
      slug: 'dev_tools/dev_stats'
      infinityScroll: false

export default VueOptions.vue settings
